

export const goodsManageListNewData = [
  {
    id: 'baseInfo',
    title: '添加专家账号',
    footerShow:'special',
    data: [
      {
        id: 'realname',
        name: '姓名',
        placeholder: '请输入姓名',
        type: 'input',
        checkType: 'required',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'realname'
      },
      {
        id: 'sex',
        name: '性别',
        placeholder: '请选择性别',
        type: 'radio',
        checkType: '',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        tips:'',
        options: [
          {
            value: '男',
            name: '男'
          },
          {
            value: '女',
            name: '女'
          },
        ],
        expand: {},
        jpath: 'sex'
      },
      {
        id: 'password',
        name: '密码',
        placeholder: '请输入密码',
        type: 'input',
        checkType: 'required',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'password'
      },
      {
        id: 'mobile',
        name: '手机号',
        placeholder: '请输入手机号',
        type: 'input',
        checkType: 'required',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'mobile'
      },
      {
        id: 'email',
        name: 'Email',
        placeholder: '请输入Email',
        type: 'input',
        checkType: '',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'email'
      },
      {
        id: 'idcard',
        name: '身份证号码',
        placeholder: '请输入身份证号码',
        type: 'input',
        checkType: '',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'idcard'
      },
      {
        id: 'workunit',
        name: '工作单位',
        placeholder: '请输入工作单位',
        type: 'input',
        checkType: '',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'workunit'
      },
      {
        id: 'position',
        name: '职务',
        placeholder: '请输入职务',
        type: 'input',
        checkType: '',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'position'
      },
      {
        id: 'jobtitle',
        name: '职称',
        placeholder: '请输入职称',
        type: 'input',
        checkType: '',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'jobtitle'
      },
      {
        id: 'avoid',
        name: '需回避的博物馆',
        placeholder: '请输入需回避的博物馆',
        type: 'select',
        checkType: '',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'avoid'
      },
      {
        id: 'bankcard',
        name: '银行卡号',
        placeholder: '请输入银行卡号',
        type: 'input',
        checkType: '',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'bankcard'
      },
      {
        id: 'bankname',
        name: '银行卡开户行',
        placeholder: '请输入银行卡开户行',
        type: 'input',
        checkType: '',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'bankname'
      },
      {
        id: 'intro',
        name: '研究专长',
        placeholder: '请输入研究专长',
        type: 'input',
        checkType: '',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'intro'
      },
      {
        id: 'egid',
        name: '博物馆专家组',
        placeholder: '请选择博物馆专家组',
        type: 'select',
        checkType: '',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        tips:'',
        options: [],
        expand: {},
        jpath: 'egid'
      },
    ]
  }
];
